<template>
  <v-container>
    <v-row
      ><v-col justify="center" md="12" lg="12">
        <v-card color="rgb(255, 0, 0, 0)">
          <v-card-title class="text-h5" style="word-break: keep-all"
            ><v-avatar dark class="white--text">
              <v-icon color="#2B2118">mdi-database-refresh</v-icon>
            </v-avatar>
            Modern Pollen Data
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>

    <!-- FILTERS PANEL -->
    <PollenModerneFilters></PollenModerneFilters>

    <v-row align-content="center" justify="center">
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        lg="12"
        xl="10"
        class="text-center"
      >
        {{ `${getFiltered.length} datasets corresponding to filters.` }}
      </v-col>
    </v-row>

    <v-row align-content="center" justify="center">
      <v-col cols="12" justify="center" xs="12" sm="12" md="12" lg="12" xl="12">
        <PollenModerneMap
          :dialog.sync="dialog"
          :feature.sync="activeDataset"
          :selected.sync="selected"
          :showonlyselected.sync="showonlyselected"
        ></PollenModerneMap> </v-col
    ></v-row>

    <!-- DATA TABLE -->
    <v-row align-content="center" justify="center">
      <v-col cols="12" justify="center" xs="12" sm="12" md="12" lg="12" xl="10">
        <v-card>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search datasets..."
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <!-- <v-btn v-if="selected.length > 0" color="success"
              >Show only selected</v-btn
            > -->
            <v-btn
              @click="showonlyselected = !showonlyselected"
              text
              class="ma-2"
              :color="showonlyselected ? '' : 'success'"
            >
              <v-icon left> mdi-eye </v-icon
              >{{
                showonlyselected
                  ? `Show All (${getFiltered.length})`
                  : `Show only selected (${selected.length})`
              }}</v-btn
            >
            <v-btn
              :disabled="selected.length === 0"
              text
              @click="clearSelection"
              class="ma-2"
              color="error"
              ><v-icon left> mdi-close-box-outline </v-icon>Clear
              Selection</v-btn
            >
            <v-btn
              :disabled="selected.length === 0"
              @click="downloadSelected"
              text
              class="ma-2"
              ><v-icon left> mdi-download </v-icon
              >{{ `Download selected (${selected.length})` }}</v-btn
            >
          </v-card-title>
          <v-card-text>
            <v-data-table
              v-model="selected"
              show-select
              item-key="id_dataset"
              :headers="headers"
              :search="search"
              :items="showonlyselected ? selected : getFiltered"
              :sort-by="['geo.properties.location', 'geo.siteName']"
            >
              <template v-slot:item.geo.siteName="{ item }">
                <span>{{
                  item.geo.siteName
                    ? item.geo.siteName.length > 18
                      ? item.geo.siteName.slice(0, 15) + "..."
                      : item.geo.siteName
                    : ""
                }}</span>
              </template>

              <template v-slot:item.archiveType="{ item }">
                <span>{{ item.archiveType.split(" - ")[0] }}</span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon class="ma-1" @click="downloadItem(item)">
                  mdi-download
                </v-icon>
                <!-- <v-icon class="ma-1" @click="openDialog(item)">
                  mdi-magnify
                </v-icon> -->
                <v-btn
                  icon
                  :to="{
                    name: 'DatasetLandingPage',
                    params: { modernfossil: 'modern', uuid: item.uuid },
                  }"
                  target="_blank"
                >
                  <v-icon class="ma-1"> mdi-magnify </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <PollenModernDetailDialog
      :dialog.sync="dialog"
      v-bind:feature="activeDataset"
      :selected:sync="selected"
    ></PollenModernDetailDialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PollenModerneMap from "../components/pollenmoderne/PollenModerneMap.vue";
import PollenModernDetailDialog from "../components/pollenmoderne/PollenModernDetailDialog.vue";
import PollenModerneFilters from "../components/pollenmoderne/PollenModerneFilters.vue";
import JSZip from "jszip";
import { saveAs } from "file-saver";
var urljoin = require("url-join");
import axios from "axios";
const HOST_ROOT = process.env.VUE_APP_ROOT_API;

export default {
  components: {
    PollenModerneMap,
    PollenModernDetailDialog,
    PollenModerneFilters,
  },
  name: "LipdPollenModerne",
  data: () => ({
    search: "",
    activeDataset: null,
    dialog: false,
    selected: [],
    showonlyselected: false,
    headers: [
      {
        text: "Country",
        align: "start",
        value: "geo.properties.location",
      },
      {
        text: "Region",
        align: "start",
        value: "geo.properties.location2",
      },
      {
        text: "Title",
        align: "start",
        value: "dataset_title",
      },
      {
        text: "Author",
        align: "start",
        value: "investigators",
      },
      {
        text: "Main Archive",
        value: "archiveType",
      },
      {
        text: "UUid",
        value: "uuid",
      },
      { text: "Actions", value: "actions", align: "right", sortable: false },
    ],
  }),
  methods: {
    ...mapActions("lipdpollenmoderne", ["fetchDatasets"]),
    openDialog(item) {
      this.activeDataset = item;
      this.dialog = true;
    },
    getChipColor(number) {
      if (number > 0) {
        return "success";
      } else {
        return "error";
      }
    },
    closeDialog() {
      this.activeDataset = null;
      this.dialog = false;
    },

    clearSelection() {
      this.selected = [];
      this.showonlyselected = false;
    },
    async downloadItem(item) {
      try {
        /* Initializing archive */
        var zip = new JSZip();
        var bag = zip.folder("bag");
        var lipd = bag.folder("data");

        /* Downloading metadata */
        var url_metadata = urljoin(
          HOST_ROOT,
          `api/modern-dataset/${item.id_dataset}/`
        );
        const response = await axios.get(url_metadata);
        lipd.file(
          "metadata.jsonld",
          JSON.stringify(response.data.json_metadata)
        );

        /* Downloading related paleodata files */
        var url_paleodata = urljoin(
          HOST_ROOT,
          `api/modern-paleodata?id_dataset=${item.id_dataset}`
        );
        const response3 = await axios.get(url_paleodata);
        let paleoFiles = response3.data;
        for (var p of paleoFiles) {
          /* console.log(JSON.stringify(p)) */
          const p_file = await axios.get(
            process.env.NODE_ENV === "production"
              ? p.paleodata_file.replace("http", "https")
              : p.paleodata_file
          );
          lipd.file(p.paleodata_title + ".csv", p_file.data);
        }

        /* Generating .lpd archive */
        zip.generateAsync({ type: "blob" }).then(function (content) {
          // see FileSaver.js
          saveAs(content, item.dataset_title + ".lpd");
        });
      } catch (error) {
        console.log(error);
      }
    },
    async downloadSelected() {
      try {
        this.selected.forEach((item) => {
          this.downloadItem(item);
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    ...mapGetters("lipdpollenmoderne", [
      "getDatasets",
      "getAuthors",
      "getCountries",
      "getArchives",
      "getFiltered",
    ]),
  },
  created() {
    this.fetchDatasets();
  },
};
</script>

<style>
</style>